import Vue from 'vue'
import VueRouter from 'vue-router'
import Login from './Login.vue'
import Home from './Home.vue'
import Register from './Register.vue'
import store from './store'
import Import from './Import.vue'

Vue.use(VueRouter)

const routes = [
  { path: '/login',
    name: 'login',
    component: Login
  },
  {
    path: '/register',
    name: 'register',
    component: Register
  },
  {
    path: '/',
    name: 'home',
    component: Home,
    beforeEnter: requireAuth
  }, {
    path: '/import',
    name: 'import',
    component: Import,
    beforeEnter: requireAuth
  }, {
    path: '*',
    component: Login
  }
]

const router = new VueRouter({
  mode: 'history',
  routes: routes
})

function requireAuth(to, from, next) {
  if (store.getters.getUserLogin) {
    next()
  } else {
    next('/login')
  }
}

export default router
